import React from "react";

function Circlesbg({ children }: { children: React.ReactNode }) {
  return (
    <div className="   bg-circles-bg bg-left -z-10 bg-repeat ">{children}</div>
  );
}

export default Circlesbg;
